import React, { useState } from 'react';
import { DATE_FORMATS, getEmailsArray, showError, showSuccess } from 'utils';
import styles from './index.module.scss';
import moment from 'moment';
import { sendWeightedAverageCostReport } from 'services';
import ActionButton from 'components/ActionButton';
import { Loading } from 'components/loading/Loading';
import DatePicker from 'components/Date/DatePicker';

const WeightedAverageCost = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [date, setDate] = useState<string>(moment().format(DATE_FORMATS.MM_DD_YYYY));
  const [time, setTime] = useState<string>('23:59');
  const [email, setEmail] = useState<string>('');
  
  const sendWeightedAverageCostReportFn = async () => {
    setLoading(true);
    try {
      if(!email){
        throw 'Please enter email to proceed.';
      }
      const dateString = moment(`${date} ${time}`).toISOString();
      await sendWeightedAverageCostReport(dateString, getEmailsArray(email));
      showSuccess('Emails will be sent shortly.');
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };
  
  const getFilter = () => (
    <div className={styles['filter-container']}>
      <div className='d-flex'>
        <div className='mr-3'>
          <div className={styles['label']}>Date</div>
          <DatePicker
            date={date}
            onChange={setDate}
            showMonthDropdown={true}
          />
        </div>
        <div>
          <div className={styles['label']}>Emails</div>
          <input
            className={'form-control'}
            disabled={loading}
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
          <div className={styles['helper']}>Use commas to separate emails</div>
        </div>
      </div>
      <ActionButton
        text={'Submit'}
        active={!loading}
        isLoading={loading}
        onClick={sendWeightedAverageCostReportFn}
        customClass={'ml-3 mt-3'}
      />
    </div>
  );
  
  const getHeader = () => (
    <div className={styles['header']}>
      <div className={styles['heading']}>Weighted Average Cost Report</div>
    </div>
  );

  return (
    <div className={styles['main-container']}>
      {loading && <Loading />}
      {getHeader()}
      {getFilter()}
    </div>
  );
};

export default WeightedAverageCost;